import SpriteSymbol from "../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "container",
  "use": "container-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"container\"><path d=\"M15.613 5H6.387A2.386 2.386 0 004 7.387v7.227A2.386 2.386 0 006.387 17h9.227a2.387 2.387 0 002.387-2.387V7.387A2.388 2.388 0 0015.613 5zm.887 9.613a.888.888 0 01-.887.887H6.387a.888.888 0 01-.887-.887V7.387c0-.489.398-.887.887-.887h9.227c.489 0 .887.398.887.887v7.226H16.5zM10.249 14h1.5V8.002h-1.5V14zm-3 0h1.5V8.002h-1.5V14zm6 0h1.5V8.002h-1.5V14z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol